import React, { useState } from "react";

const pad = (n) => (n < 10 ? "0" + n : String(n));

// A local calendar day as YYYY-MM-DD, `days` from today.
export const dayFromToday = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// "2027-11-05" -> "November 5, 2027" without any timezone shift.
export const formatDay = (day) => {
  if (!day) return "";
  const [y, m, d] = day.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
};

// "Valid Till <date> ✎": the pencil opens a calendar for the giver's own date
// (today up to `maxDays` from now). onSave(day) may return a promise; the
// picker closes when it resolves to true. Without onSave the date is read-only.
export default function ValidTill({ day, maxDays, onSave, label = "Valid Till" }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(day || "");
  const [busy, setBusy] = useState(false);

  const open = () => {
    setValue(day && day >= dayFromToday(0) ? day : dayFromToday(365));
    setEditing(true);
  };

  const save = async () => {
    setBusy(true);
    const ok = await onSave(value);
    setBusy(false);
    if (ok) setEditing(false);
  };

  return (
    <span className="vs-validtill">
      {label} <b>{formatDay(day)}</b>
      {onSave && !editing && (
        <button type="button" className="vs-pencil" onClick={open} aria-label="Change the Valid Till date" title="Change date">
          <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path d="M4 20h4L19 9l-4-4L4 16v4z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            <path d="M13.5 6.5l4 4" fill="none" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        </button>
      )}
      {onSave && editing && (
        <span className="vs-validtill-edit">
          <input
            type="date"
            className="vsr-input"
            value={value}
            min={dayFromToday(0)}
            max={dayFromToday(maxDays || 1095)}
            onChange={(e) => setValue(e.target.value)}
            aria-label="Valid Till date"
          />
          <button type="button" className="vsr-btn vsr-btn-sm" disabled={busy || !value} onClick={save}>
            {busy ? "Saving…" : "Save"}
          </button>
          <button type="button" className="vsr-link" disabled={busy} onClick={() => setEditing(false)}>
            Cancel
          </button>
        </span>
      )}
    </span>
  );
}
